import { createGlobalStyle } from 'styled-components';

interface ModalProps {
  theme: any | string;
}

const GlobalStyle = createGlobalStyle<ModalProps>`

  .ant-select-arrow {
    color: ${(props) => props.theme.colors.textPrimary};
    background-color: ${(props) => props.theme.colors.primary};
  }

  .ant-popover-inner-content {
    display: flex;
    flex-direction: column;
    align-items: center;

    .ant-popover-message-title {
      padding-right: 1rem;
    }
  }

  .ant-modal-content,.ant-modal-header,.ant-modal-content .ant-table,.ant-table-thead {
    color: ${(props) => props.theme.colors.textPrimary};
    background-color:  ${(props) => props.theme.colors.primary};
  }

  .ant-modal-title,.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-description, .ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-description {
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-table-thead th.ant-table-column-has-sorters:hover {
    background-color: ${(props) => props.theme.colors.hover};
  }

  .ant-table-tbody > tr.ant-table-row:hover > td {
    background-color: ${(props) => props.theme.colors.hover};
    color: ${(props) => props.theme.colors.textPrimary};
  }

  td.ant-table-column-sort{
    background-color: ${(props) => props.theme.colors.primary};
  }

  .ant-modal-body {
    background-color: ${(props) => props.theme.colors.primary};
  }

  .ant-table-column-sorters-with-tooltip {
    background-color: ${(props) => props.theme.colors.headerTable};
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-table-column-sorters-with-tooltip:hover {
    background-color: ${(props) => props.theme.colors.hover};
  }

  .ant-steps-vertical.ant-steps-small .ant-steps-item-container .ant-steps-item-title {
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-steps {
    background-color: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {
    background-color: ${(props) => props.theme.colors.stepsStatus};
  }

  input[type='text'], input[type='password'], input[type='number'], textarea {
    background-color: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-btn-ghost {
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-btn-primary[disabled], .ant-btn-primary[disabled]:hover, .ant-btn-primary[disabled]:focus, .ant-btn-primary[disabled]:active {
    background-color: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-select {
    background-color: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-input-number-handler {
    color: ${(props) => props.theme.colors.primary};
    background-color: ${(props) => props.theme.colors.primary};
  }

  .ant-select-multiple .ant-select-selection-item  {
    background-color: ${(props) => props.theme.colors.primary};
  }

  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    background-color: ${(props) => props.theme.colors.inputSelect};
  }

  .ant-select-clear {
    color: ${(props) => props.theme.colors.textPrimary};
    background-color: ${(props) => props.theme.colors.primary};
  }

  .ant-drawer-body {
    background-color: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-drawer-header {
    background-color: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-scroll-number-only > p.ant-scroll-number-only-unit {
    color: ${(props) => props.theme.colors.headerTable};
  }

  .ant-btn-dashed {
    color: ${(props) => props.theme.colors.textPrimary};
    background-color: ${(props) => props.theme.colors.primary};
  }

  .ant-table .ant-table-expanded-row-fixed {
    color: ${(props) => props.theme.colors.textPrimary};
    background-color: ${(props) => props.theme.colors.primary};
  }

  .eBYxno h4 {
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-table-thead > tr > th {
    color: ${(props) => props.theme.colors.textPrimary};
    background-color: ${(props) => props.theme.colors.primary};
  }

  .ant-table-thead > tr > th:hover {
    background-color: ${(props) => props.theme.colors.hover};
  }

  .ant-row {
    color: ${(props) => props.theme.colors.textPrimary};
    background-color: ${(props) => props.theme.colors.primary};
  }

  .dVsvWR .box-date {
    color: ${(props) => props.theme.colors.textPrimary};
    background-color: ${(props) => props.theme.colors.primary};
  }

  .dVsvWR .info {
    color: ${(props) => props.theme.colors.textPrimary};
    background-color: ${(props) => props.theme.colors.primary};
  }

  .ant-form label {
    color: ${(props) => props.theme.colors.textPrimary};
    background-color: ${(props) => props.theme.colors.primary};
  }

  .ant-alert {
    color: ${(props) => props.theme.colors.textPrimary};
    background-color: ${(props) => props.theme.colors.primary};
  }

  .ant-alert-message {
    color: ${(props) => props.theme.colors.textPrimary};
    background-color: ${(props) => props.theme.colors.primary};
  }

  .ant-input-affix-wrapper {
    color: ${(props) => props.theme.colors.textPrimary};
    background-color: ${(props) => props.theme.colors.primary};
  }

  span.ant-radio + * {
    color: ${(props) => props.theme.colors.textPrimary};
    background-color: ${(props) => props.theme.colors.primary};
  }

  .ant-input[disabled] {
    color: ${(props) => props.theme.colors.textPrimary};
    background-color: ${(props) => props.theme.colors.primary};
  }

  .ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector {
    color: ${(props) => props.theme.colors.textPrimary};
    background-color: ${(props) => props.theme.colors.primary};
  }

  .ant-input {
    color: ${(props) => props.theme.colors.textPrimary};
    background-color: ${(props) => props.theme.colors.primary};
  }

  input {
    color: ${(props) => props.theme.colors.textPrimary};
    background-color: ${(props) => props.theme.colors.primary};
  }

  .ant-modal-confirm-body .ant-modal-confirm-title {
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-modal-confirm-body .ant-modal-confirm-content {
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .brIZDq .rbc-calendar *, .brIZDq .rbc-calendar *:before, .brIZDq .rbc-calendar *:after {
    color: ${(props) => props.theme.colors.textPrimary};
    background-color: ${(props) => props.theme.colors.primary};
  }

  .brIZDq .rbc-time-view-resources .rbc-time-gutter, .brIZDq .rbc-time-view-resources .rbc-time-header-gutter {
    color: ${(props) => props.theme.colors.textPrimary};
    background-color: ${(props) => props.theme.colors.primary};
  }

  .brIZDq .rbc-day-slot .rbc-event {
    color: ${(props) => props.theme.colors.textPrimary};
    background-color: ${(props) => props.theme.colors.primary};
  }

  .ant-form-item-label > label {
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-tabs-tab-btn {
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-btn[disabled] {
    color: ${(props) => props.theme.colors.btnDisable};
    background-color: ${(props) => props.theme.colors.primary};
  }

  .ant-table-tbody > tr.ant-table-placeholder:hover > td {
    background-color: ${(props) => props.theme.colors.hover};
  }

  .ant-empty-normal {
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-dropdown-menu-item, .ant-dropdown-menu-submenu-title {
    background-color: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-dropdown-menu {
    background-color: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-dropdown-menu-item:hover, .ant-dropdown-menu-submenu-title:hover {
    background-color: ${(props) => props.theme.colors.hover};
  }

  .ant-btn-dangerous.ant-btn-text {
    color: ${(props) => props.theme.colors.btnDanger};
  }

  .ant-btn-dangerous.ant-btn-text[disabled] {
    color: ${(props) => props.theme.colors.btnDanger};
  }

  .ant-btn[disabled]:hover {
    background-color: ${(props) => props.theme.colors.hover};
  }

  .ant-picker {
    background-color: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-picker-input > input {
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-input-handler {
    color: ${(props) => props.theme.colors.textPrimary};
    background-color: ${(props) => props.theme.colors.primary};
  }

  .sc-jNrxex, .kYTCFA, .ant-collapse, .ant-collapse-icon-position-left{
    color: ${(props) => props.theme.colors.textPrimary} !important;
    background-color: ${(props) => props.theme.colors.primary} !important;

  }
  .ant-collapse-content, .ant-collapse-content-active{
    color: ${(props) => props.theme.colors.textPrimary} !important;
    background-color: ${(props) => props.theme.colors.primary} !important;
  }

  // Ordem de carga
  .themeOrdemCargaAcao button{
    color: ${(props) => props.theme.colors.textPrimary} !important;
    background-color: ${(props) => props.theme.colors.primary} !important;
  }

// Agendamentos agendamentos e Editar
  .themeButomAgendamento button, .themeEditar div div, .themeEditar .anticon{
    color: ${(props) => props.theme.colors.textPrimary} !important;
    background-color: ${(props) => props.theme.colors.primary} !important;
  }

  .themeHorariosDisponiveis{
    color: ${(props) => props.theme.colors.textSecondary} !important;
  }

  .ant-col h4{
    color: ${(props) => props.theme.colors.textSecondary} !important;
  }

  .themeBackgroudButton{
    background-color: ${(props) => props.theme.colors.backgroundButton} !important;
  }



  //Agendamento Consulta agendamento
  .contConsultaAgendamento .infoContainer div,
  .caixa .numero,
  .grade>div>div>div>div,
  .cdConsultaAgendamento,
  .anticon-close,
  /* .ant-col div, */
  .ant-layout h1,
  .ant-collapse-content-box div p,
  .ant-card-body p,
  .ant-picker-header button,
  .ant-picker-content tr th,
  .ant-picker-content tr td,
  .contConsultaAgendamento

  {
    color: ${(props) => props.theme.colors.textPrimary} !important;
  }
  .rbc-time-column, .themeMobileContainer, .ant-card-body, .ant-collapse-content-box div, .ant-picker-panel{
    background-color: ${(props) => props.theme.colors.primary} !important;
  }
  .themeTableConsultaAgendamento,
  .themeTableConsultaAgendamento div,
  .themeModalConsultaAgendamento section *
  {
    color: ${(props) => props.theme.colors.textPrimary};
    background-color: ${(props) => props.theme.colors.primary};
  }

  .themeModalConsultaAgendamento .ant-collapse-header{
    color: ${(props) => props.theme.colors.textPrimary} !important;

  }

  .ant-collapse-header,
  .ant-modal-close-icon,
  .ant-collapse-content-box .themeData,
  .themeInfosAtendimento,
  .ant-list,
  .ant-list-split,
  .ant-list-grid,
  .themeColorMobile p span,
  .ant-collapse-arrow svg,
 .themeColorContainerPanelHeader >span,
 .ant-collapse-header >span ,
 .nameUser,
 .ant-modal-body h2
 .ant-collapse-content-box span,
 .themeColorMobile > span,
 .themeColorMobileContainer section p span:last-child
  {
    color: ${(props) => props.theme.colors.textPrimary} ;
    background-color: ${(props) => props.theme.colors.primary} ;
  }
  .ant-card-head{
    background-color: ${(props) => props.theme.colors.primary} !important;
  }

  //Ajuda
  .themeMenuAjuda a li{
    color: ${(props) => props.theme.colors.textPrimary} !important;
  }
  .themeMenuAjuda a li:hover{
    color: ${(props) => props.theme.colors.hoverMenu} !important;
  }

  .themeRotas h1, .themeRotas h2{
    color: ${(props) => props.theme.colors.textPrimary} !important;
  }

  // sla
  .themeSLA {
    color: ${(props) => props.theme.colors.textPrimary} !important;
    background-color: ${(props) => props.theme.colors.primary} !important;

    .ContainerOptions{
      li {
        color: ${(props) => props.theme.colors.textPrimary};
        &:hover {
          color: ${(props) => props.theme.colors.hoverMenu};
        }
      }
    }

    .containerTI .ti h2{
      color: ${(props) => props.theme.colors.textPrimary} !important;
    }
    .containerTI div{
      color: ${(props) => props.theme.colors.textPrimary} !important;
    }

  }

  .themeDashboard{
    color: ${(props) => props.theme.colors.textPrimary} ;
    background-color: ${(props) => props.theme.colors.primary} ;
  }
`;

export default GlobalStyle;
